import exp from "constants";
import { CgEdit, CgEditProps } from "../../components/common";
import { required, useNotify, useRedirect, useTranslate } from "react-admin";
import useRoles from "./useRole";
import { Resources } from "../resource";
import RoleForm from "./RoleForm";
import { Box, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Input, InputLabel, Button as MUIButton, Stack, TextField } from "@mui/material";
import { Iconify } from "src/components/iconify";
import XTextInput from "../../components/XTextInput";
import { useState } from "react";
import { PermissionButton } from "src/routes/components/permission-button";


const EditPopupV2 = (props: CgEditProps) => {
    const redirect = useRedirect();
    const notify = useNotify();
    const t = useTranslate();
    const { updateRole } = useRoles();
    const { onRefresh, ...rest } = props;
    const [nameRole, setNameRole] = useState<string>(props?.roleItem?.name);
    const [nameError, setNameError] = useState<boolean>(false);
    const handleOnSubmit = async() => {
      if (!nameRole.trim()) {
        setNameError(true);
        return;
      }
      try {
        if (!props.id) {
            notify("Missing Role ID", { type: 'error', autoHideDuration: 1000 });
            return;
        }

        const roleUpdateTasks: Promise<void>[] = [];
        roleUpdateTasks.push(updateRole(props.id, nameRole));
        if (roleUpdateTasks.length === 0) {
            notify("Nothing to update", { type: 'info', autoHideDuration: 1000 });
            return;
        }

        await Promise.all(roleUpdateTasks);

        notify("Update Successfully", { type: 'success', autoHideDuration: 1000 });
        props.onClose?.();
        props.onRefresh?.();
    } catch (error: any) {
        notify(error?.response?.data?.message || "Update Error", { type: 'error', autoHideDuration: 1000 });
    }

    }
    return (
      
      <Box>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 2 }}>
            {t('module.roles.editRole')}
            </DialogTitle>
            <DialogContent>
              <Box sx={{ p: 3, pl: 0, pr:0 }}>
                <Stack spacing={3}>
                  <FormControl>
                    <TextField 
                      required 
                      value={nameRole}
                      onChange={(e) => setNameRole(e.target.value)}
                      label={t('module.roles.name')} 
                      variant="outlined" 
                      error={nameError}
                      helperText={nameError ? t('ra.validation.required') : ''}
                    />
                  </FormControl>
                </Stack>
              </Box>
            
            </DialogContent>
            <DialogActions>

              <MUIButton variant="outlined" onClick={props.onClose}>
                  {t('actions.cancel')}
              </MUIButton>
              <PermissionButton resource="roles" action="update">
                <MUIButton
                    variant="contained"
                    startIcon={<Iconify icon="eva:save-fill" />}
                    onClick={handleOnSubmit}
                >
                    {t('ra.action.save')}
                </MUIButton>
              </PermissionButton>
            </DialogActions>
      </Box>
    );
};
export default EditPopupV2;